import { render, staticRenderFns } from "./VirtuallySendGoods.vue?vue&type=template&id=6a0678e7"
import script from "./VirtuallySendGoods.vue?vue&type=script&lang=js"
export * from "./VirtuallySendGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports